<template>
	<ul class="tier-highlights-list">
		<li
			v-for="point in tierHighlightsToDisplay"
			:key="point.text"
			class="tier-highlight-item"
		>
			<CheckmarkFilled16
				v-if="point.included !== false"
				class="tier-highlight-icon sgnl-icon-color-success"
			/>
			<SubtractFilled16
				v-else
				class="tier-highlight-icon"
			/>
			<!--
				v-html is intentional here — point.text may contain simple inline
				HTML for formatting (e.g. <strong>, <code>).
				IMPORTANT: Only ever pass statically-defined, developer-controlled
				TierFeatureHighlight data to this component. Never pass user input
				or API-sourced strings without DOMPurify sanitization first.
			-->
			<span
				:class="point.included !== false ? 'tier-highlight-text-included' : 'tier-highlight-text-excluded'"
				v-html="point.text"
			/>
		</li>
	</ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { TierFeatureHighlight } from "@/js/tierconfig";

// Carbon Icons
import CheckmarkFilled16 from "@carbon/icons-vue/es/checkmark--filled/16";
import SubtractFilled16 from "@carbon/icons-vue/es/subtract--filled/16";

export default defineComponent({
	name: "TierHighlightsList",
	components: { CheckmarkFilled16, SubtractFilled16 },
	props: {
		tierHighlightsToDisplay: {
			type: Array as PropType<TierFeatureHighlight[]>,
			default: () => [],
		},
	},
});
</script>

<style lang="scss" scoped>
.tier-highlights-list {
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: var(--sgnl-space-6);
}

.tier-highlight-item {
	display: flex;
	align-items: center;
	gap: var(--sgnl-space-8);
}

.tier-highlight-icon {
	flex-shrink: 0;
}

.tier-highlight-text-included {
	color: var(--sgnl-default-secondary-text);
	font-size: var(--sgnl-font-size-paragraph-s);
	font-style: normal;
	font-weight: 400;
	line-height: var(--sgnl-font-line-height-paragraph-s);
	letter-spacing: var(--sgnl-font-letter-spacing0);
}

.tier-highlight-text-excluded {
	color: var(--sgnl-default-secondary-text);
	font-size: var(--sgnl-font-size-paragraph-s);
	font-style: normal;
	font-weight: 400;
	line-height: var(--sgnl-font-line-height-paragraph-s);
	letter-spacing: var(--sgnl-font-letter-spacing0);
}
</style>
